import { createAction, createReducer } from "@reduxjs/toolkit";

export const addPool = createAction('addPool')
export const removePool = createAction('removePool')
export const resetPool = createAction('resetPool')

const initialState = {
    value: []
};

export const fundingPools = createReducer(initialState, {
    [addPool]: (state, action) => {
        state.value.push(action.payload)
    },
    [removePool]: (state, action) => {
        state.value.splice(
            state.value.findIndex(input => input === action.payload), 1
        )
    },
    [resetPool]: (state) => {
        state.value = initialState
    }
}
);

//used in
// add pool modal - adding a newly created pool to the rest of the pools that were stored when the API was originally queried
// --> pool name button - toggling the pool... this needs to be moved to a new reducer that is combined with the table values
